"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateBasicFlashcardInfoList = void 0;
const models_1 = require("../models");
const BasicFlashcardInfoListSchema = models_1.BasicFlashcardInfoSchema.array();
const validateBasicFlashcardInfoList = (x) => BasicFlashcardInfoListSchema.safeParse(x);
exports.validateBasicFlashcardInfoList = validateBasicFlashcardInfoList;
//# sourceMappingURL=flashcard_args_types.js.map